import React, { Component } from 'react'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Hint from '~/Common-Objects/UI/Hint/Hint'
import Icons from '~/Common-Objects/UI/Icons/index'
import OptionsDropdown from '~/Common-Objects/UI/OptionsDropdown/OptionsDropdown'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import TierLimitHolder from '~/Common-Objects/UI/Cards/TierLimitHolder'
import { connect } from 'react-redux'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import i18n from '~/i18n'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import PermissionChecker from '~/Classes/permissions'
import TierPermissions from '../../../../Classes/tierPermissions'
import Add from './add'
import DeleteDrawer from './delete'

@connect((store) => {
    return { accountMaster: store.accountMaster, permissionStore: store.permission, siteMaster: store.siteMaster }
})
class Mailboxes extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ready: false,
            tableData: []
        }
        this.getMailboxes = this.getMailboxes.bind(this)
        this.addMailbox = this.addMailbox.bind(this)
        this.editMailbox = this.editMailbox.bind(this)
        this.deleteMailbox = this.deleteMailbox.bind(this)
    }

    componentDidMount() {
        this.getMailboxes()
    }

    getMailboxes() {
        var writeAccess = PermissionChecker('company', this.props.permissionStore.permissions, 'write')
        axios.get('/accountMaster/mailbox').then((response) => {
            this.setState({
                tableData: response.data.Mailboxes.map((row) => {
                    var obj = {
                        emailAddress: {
                            headerValue: i18n.t('company:mailboxes.emailAddress'),
                            value: row.emailAddress,
                            orderBy: false
                        },
                        user: {
                            headerValue: i18n.t('company:mailboxes.username'),
                            value: row.user,
                            orderBy: false
                        },
                        host: {
                            headerValue: i18n.t('company:mailboxes.host'),
                            value: row.host,
                            orderBy: false
                        },
                        port: {
                            headerValue: i18n.t('company:mailboxes.port'),
                            value: row.port,
                            orderBy: false
                        },
                        tls: {
                            headerValue: i18n.t('company:mailboxes.tls'),
                            value: row.tls ? 'Yes' : 'No',
                            orderBy: false
                        },
                        lastSync: {
                            headerValue: i18n.t('company:mailboxes.lastSync'),
                            value: row.lastSync
                                ? DateTimeFunctions.formatDateTime(row.lastSync)
                                : i18n.t('company:mailboxes.never'),
                            orderBy: false
                        },
                        nextSync: {
                            headerValue: i18n.t('company:mailboxes.nextSync'),
                            value: row.nextSync
                                ? DateTimeFunctions.formatDateTime(row.nextSync)
                                : i18n.t('company:mailboxes.soon'),
                            orderBy: false
                        },
                        active: {
                            headerValue: i18n.t('company:mailboxes.active'),
                            value: row.active ? i18n.t('company:mailboxes.yes') : i18n.t('company:mailboxes.no'),
                            orderBy: false
                        },
                        optionsCol: {
                            headerValue: ' ',
                            value: (
                                <OptionsDropdown popWidth='150px'>
                                    <ul>
                                        {writeAccess && (
                                            <li>
                                                <a
                                                    onClick={() => {
                                                        this.editMailbox(row)
                                                    }}
                                                >
                                                    {i18n.t('edit')}
                                                </a>
                                            </li>
                                        )}
                                        {writeAccess && (
                                            <li>
                                                <a
                                                    onClick={() => {
                                                        this.deleteMailbox(row)
                                                    }}
                                                >
                                                    {i18n.t('delete')}
                                                </a>
                                            </li>
                                        )}
                                        <li>
                                            <a
                                                onClick={() =>
                                                    this.props.history.push('/cp/company/mailboxes/' + row.id)
                                                }
                                            >
                                                View History
                                            </a>
                                        </li>
                                    </ul>
                                </OptionsDropdown>
                            ),
                            orderBy: false,
                            fixed: true,
                            width: 20
                        }
                    }
                    return obj
                }),
                ready: true
            })
        })
    }

    addMailbox() {
        var drawerContent = (
            <Add
                history={this.props.history}
                finish={() => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'left', null))
                    this.getMailboxes()
                }}
                cancel={() => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'left', null))
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'left', drawerContent, true, 500))
    }

    editMailbox(mailbox) {
        var drawerContent = (
            <Add
                mailbox={mailbox}
                history={this.props.history}
                finish={() => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'left', null))
                    this.getMailboxes()
                }}
                cancel={() => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'left', null))
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'left', drawerContent, true, 500))
    }

    deleteMailbox(mailbox) {
        var drawerContent = (
            <DeleteDrawer
                confirm={() => {
                    axios.delete('/accountMaster/mailbox/' + mailbox.id).then(() => {
                        this.getMailboxes()
                        this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'left', null))
                    })
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'left', drawerContent, true))
    }

    render() {
        var writeAccess = PermissionChecker('company', this.props.permissionStore.permissions, 'write')
        var noneAvailable = (
            <span>
                {i18n.t('company:mailboxes.noneFound')}{' '}
                {writeAccess && <a onClick={this.addMailbox}> {i18n.t('company:mailboxes.addAMailBox')} </a>}
            </span>
        )

        const replyPermissions = TierPermissions('replyTracking', this.props.accountMaster)
        const allowed = replyPermissions.allowed
        console.log(replyPermissions)

        return (
            <div>
                <Row>
                    <Column xs={12} sm={6} className='mar-b25 quickFlex'>
                        {this.props.siteMaster.siteId == 1 && (
                            <Hint
                                iconLeft={
                                    <Icons
                                        icon='questionCircle'
                                        color='#2B2F41'
                                        style={{ height: 16, width: 16 }}
                                    />
                                }
                                href='https://transpond.io/support/reporting-and-performance-insights/reply-tracking'
                                className='mar-l0'
                            >
                                Find out what Reply Tracking is, and how it works.
                            </Hint>
                        )}
                    </Column>
                    <Column xs={12} sm={6} className='text-right mar-b25'>
                        {writeAccess && (
                            <Button
                                className='button-primary'
                                onClick={this.addMailbox}
                                disabled={!allowed}
                                iconLeft={<Icons icon='plus' />}
                            >
                                {i18n.t('company:mailboxes.addAMailBox')}
                            </Button>
                        )}
                    </Column>
                </Row>

                {allowed && (
                    <Paper isLoading={!this.state.ready}>
                        <DataTable1
                            noResultsTxt={noneAvailable}
                            loadingData={!this.state.ready}
                            tableData={this.state.tableData}
                            width='100%'
                            pageSize='100'
                            hasCheckBoxes='no'
                        />
                    </Paper>
                )}

                {!allowed && (
                    <TierLimitHolder
                        err='tierForbids'
                        tierName={this.props.accountMaster.tier.name}
                        type='Reply Tracking'
                    />
                )}
            </div>
        )
    }
}

export default Mailboxes
